"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
Video.defaultProps = {
    className: ""
};
exports.default = react_1.default.memo(Video);
function Video(props) {
    // For some reason it is necessary to specifically set the height of the video's parent element to that of the video
    // otherwise some spurious padding appears at the bottom of the parent element
    const videoRef = react_1.useRef(null);
    react_1.useEffect(() => {
        const ro = new ResizeObserver((entries) => {
            for (let entry of entries) {
                const parent = entry.target.parentNode;
                if (parent) {
                    parent.style.height = `${entry.contentRect.height}px`;
                }
            }
        });
        if (ro.observe && videoRef.current) {
            ro.observe(videoRef.current);
        }
    }, []);
    return react_1.default.createElement("video", { ref: videoRef, className: props.className, controls: true },
        react_1.default.createElement("source", { src: props.src }),
        "Your browser does not support the video tag");
}
